export default __webpack_public_path__ + "static/media/avatar2.b8132c3c.png";